import React, { useState } from 'react';
import { useContent } from '../../contexts/ContentContext';
import ImageUpload from './ImageUpload';
import PDFUpload from './PDFUpload';
import './SimpleFormationsAdmin.css';

const SimpleFormationsAdmin = () => {
  const { content, updateContent } = useContent();
  const [expandedFormation, setExpandedFormation] = useState(null);
  
  const formations = content?.formations?.formationsGrid?.formations || [];

  const handleFieldChange = (formationIndex, field, value) => {
    const updatedFormations = [...formations];
    updatedFormations[formationIndex] = {
      ...updatedFormations[formationIndex],
      [field]: value
    };
    
    updateContent('formations.formationsGrid.formations', updatedFormations);
  };

  const handleArrayFieldChange = (formationIndex, field, arrayIndex, value) => {
    const updatedFormations = [...formations];
    const updatedArray = [...(updatedFormations[formationIndex][field] || [])];
    updatedArray[arrayIndex] = value;
    updatedFormations[formationIndex] = {
      ...updatedFormations[formationIndex],
      [field]: updatedArray
    };
    
    updateContent('formations.formationsGrid.formations', updatedFormations);
  };

  const addArrayItem = (formationIndex, field, template) => {
    const updatedFormations = [...formations];
    const currentArray = updatedFormations[formationIndex][field] || [];
    updatedFormations[formationIndex] = {
      ...updatedFormations[formationIndex],
      [field]: [...currentArray, template]
    };
    
    updateContent('formations.formationsGrid.formations', updatedFormations);
  };

  const removeArrayItem = (formationIndex, field, arrayIndex) => {
    const updatedFormations = [...formations];
    const updatedArray = [...(updatedFormations[formationIndex][field] || [])];
    updatedArray.splice(arrayIndex, 1);
    updatedFormations[formationIndex] = {
      ...updatedFormations[formationIndex],
      [field]: updatedArray
    };
    
    updateContent('formations.formationsGrid.formations', updatedFormations);
  };

  const toggleFormation = (index) => {
    setExpandedFormation(expandedFormation === index ? null : index);
  };

  return (
    <div className="simple-formations-admin">
      <div className="admin-header">
        <h2>Formations Admin</h2>
        <p>Edit all formation content - {formations.length} formations</p>
      </div>

      <div className="formations-list">
        {formations.map((formation, index) => (
          <div key={formation.id || index} className="formation-admin-card">
            
            {/* Formation Header */}
            <div className="formation-header" onClick={() => toggleFormation(index)}>
              <div className="formation-title-info">
                <h3>{formation.title || 'Formation sans titre'}</h3>
                <p>{formation.subtitle} • Instructeur: {formation.instructor}</p>
              </div>
              <button className="toggle-btn">
                {expandedFormation === index ? '▼' : '▶'}
              </button>
            </div>

            {/* Formation Content - Expanded */}
            {expandedFormation === index && (
              <div className="formation-content">
                
                {/* Basic Info */}
                <div className="section">
                  <h4>Information de base</h4>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Titre</label>
                      <input 
                        type="text" 
                        value={formation.title || ''} 
                        onChange={(e) => handleFieldChange(index, 'title', e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Sous-titre</label>
                      <input 
                        type="text" 
                        value={formation.subtitle || ''} 
                        onChange={(e) => handleFieldChange(index, 'subtitle', e.target.value)}
                      />
                    </div>
                  </div>
                  
                  <div className="form-row">
                    <div className="form-group">
                      <label>Instructeur</label>
                      <input 
                        type="text" 
                        value={formation.instructor || ''} 
                        onChange={(e) => handleFieldChange(index, 'instructor', e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Couleur</label>
                      <select 
                        value={formation.color || ''} 
                        onChange={(e) => handleFieldChange(index, 'color', e.target.value)}
                      >
                        <option value="">Choisir une couleur</option>
                        <option value="blue">Bleu</option>
                        <option value="green">Vert</option>
                        <option value="purple">Violet</option>
                        <option value="red">Rouge</option>
                        <option value="orange">Orange</option>
                        <option value="cyan">Cyan</option>
                        <option value="pink">Rose</option>
                        <option value="yellow">Jaune</option>
                        <option value="indigo">Indigo</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Description</label>
                    <textarea 
                      value={formation.description || ''} 
                      onChange={(e) => handleFieldChange(index, 'description', e.target.value)}
                      rows={3}
                    />
                  </div>
                </div>

                {/* Images */}
                <div className="section">
                  <h4>Images</h4>
                  <div className="images-row">
                    <div className="image-upload-group">
                      <label>Photo de formation (Proportion 16:9)</label>
                      <ImageUpload
                        value={formation.formationPhoto || ''}
                        onChange={(value) => handleFieldChange(index, 'formationPhoto', value)}
                        placeholder="Télécharger photo de formation"
                      />
                      <small style={{color: '#6b7280', fontSize: '12px', display: 'block', marginTop: '8px'}}>
                        Recommandé: 1600x900px (proportion 16:9)
                      </small>
                    </div>
                    <div className="image-upload-group">
                      <label>Photo de l'instructeur</label>
                      <ImageUpload
                        value={formation.instructorPhoto || ''}
                        onChange={(value) => handleFieldChange(index, 'instructorPhoto', value)}
                        placeholder="Télécharger photo de l'instructeur"
                      />
                    </div>
                  </div>
                </div>

                {/* Instructor Details */}
                <div className="section">
                  <h4>Détails de l'Instructeur</h4>
                  <div className="form-group">
                    <label>Titre de l'instructeur</label>
                    <input 
                      type="text" 
                      value={formation.instructorTitle || ''} 
                      onChange={(e) => handleFieldChange(index, 'instructorTitle', e.target.value)}
                      placeholder="Ex: Formateur Expert, Chirurgien-Dentiste, Professeur..."
                    />
                  </div>
                  <div className="form-group">
                    <label>Biographie de l'instructeur</label>
                    <textarea 
                      value={formation.instructorBio || ''} 
                      onChange={(e) => handleFieldChange(index, 'instructorBio', e.target.value)}
                      rows={3}
                      placeholder="Courte description de l'instructeur, son expérience, ses qualifications..."
                    />
                  </div>
                  <div className="form-group">
                    <label>CV de l'instructeur (PDF)</label>
                    <PDFUpload
                      value={formation.instructorCV || ''}
                      onChange={(url) => handleFieldChange(index, 'instructorCV', url)}
                      label="Télécharger le CV (PDF)"
                    />
                    <small style={{color: '#6b7280', fontSize: '12px', display: 'block', marginTop: '8px'}}>
                      Un bouton "Voir le CV" apparaîtra sur la page de formation
                    </small>
                  </div>
                </div>

                {/* Objectives */}
                <div className="section">
                  <h4>Objectifs</h4>
                  {(formation.objectives || []).map((objective, objIndex) => (
                    <div key={objIndex} className="array-item">
                      <input 
                        type="text" 
                        value={objective || ''} 
                        onChange={(e) => handleArrayFieldChange(index, 'objectives', objIndex, e.target.value)}
                        placeholder="Objectif de formation"
                      />
                      <button 
                        onClick={() => removeArrayItem(index, 'objectives', objIndex)}
                        className="remove-btn"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                  <button 
                    onClick={() => addArrayItem(index, 'objectives', '')}
                    className="add-btn"
                  >
                    + Ajouter objectif
                  </button>
                </div>

                {/* Program */}
                <div className="section">
                  <h4>Programme</h4>
                  {(formation.program || []).map((module, moduleIndex) => (
                    <div key={moduleIndex} className="program-module">
                      <div className="module-header">
                        <div className="form-row">
                          <input 
                            type="text" 
                            value={module.module || ''} 
                            onChange={(e) => handleArrayFieldChange(index, 'program', moduleIndex, { ...module, module: e.target.value })}
                            placeholder="Module X"
                            className="module-name"
                          />
                          <input 
                            type="text" 
                            value={module.title || ''} 
                            onChange={(e) => handleArrayFieldChange(index, 'program', moduleIndex, { ...module, title: e.target.value })}
                            placeholder="Titre du module"
                            className="module-title"
                          />
                          <input 
                            type="text" 
                            value={module.duration || ''} 
                            onChange={(e) => handleArrayFieldChange(index, 'program', moduleIndex, { ...module, duration: e.target.value })}
                            placeholder="Durée"
                            className="module-duration"
                          />
                          <button 
                            onClick={() => removeArrayItem(index, 'program', moduleIndex)}
                            className="remove-btn"
                          >
                            ✕
                          </button>
                        </div>
                      </div>
                      <div className="module-content">
                        {(module.content || []).map((content, contentIndex) => (
                          <div key={contentIndex} className="array-item">
                            <input 
                              type="text" 
                              value={content || ''} 
                              onChange={(e) => {
                                const updatedContent = [...(module.content || [])];
                                updatedContent[contentIndex] = e.target.value;
                                handleArrayFieldChange(index, 'program', moduleIndex, { ...module, content: updatedContent });
                              }}
                              placeholder="Contenu du module"
                            />
                            <button 
                              onClick={() => {
                                const updatedContent = [...(module.content || [])];
                                updatedContent.splice(contentIndex, 1);
                                handleArrayFieldChange(index, 'program', moduleIndex, { ...module, content: updatedContent });
                              }}
                              className="remove-btn"
                            >
                              ✕
                            </button>
                          </div>
                        ))}
                        <button 
                          onClick={() => {
                            const updatedContent = [...(module.content || []), ''];
                            handleArrayFieldChange(index, 'program', moduleIndex, { ...module, content: updatedContent });
                          }}
                          className="add-content-btn"
                        >
                          + Ajouter contenu
                        </button>
                      </div>
                    </div>
                  ))}
                  <button 
                    onClick={() => addArrayItem(index, 'program', { module: '', title: '', duration: '', content: [] })}
                    className="add-btn"
                  >
                    + Ajouter module
                  </button>
                </div>

                {/* Sessions */}
                <div className="section">
                  <h4>Sessions</h4>
                  {(formation.sessions || []).map((session, sessionIndex) => (
                    <div key={sessionIndex} className="session-item">
                      <div className="form-row">
                        <input 
                          type="text" 
                          value={session.date || ''} 
                          onChange={(e) => handleArrayFieldChange(index, 'sessions', sessionIndex, { ...session, date: e.target.value })}
                          placeholder="Date"
                        />
                        <input 
                          type="text" 
                          value={session.location || ''} 
                          onChange={(e) => handleArrayFieldChange(index, 'sessions', sessionIndex, { ...session, location: e.target.value })}
                          placeholder="Lieu"
                        />
                        <input 
                          type="text" 
                          value={session.spots || ''} 
                          onChange={(e) => handleArrayFieldChange(index, 'sessions', sessionIndex, { ...session, spots: e.target.value })}
                          placeholder="Places disponibles"
                        />
                        <button 
                          onClick={() => removeArrayItem(index, 'sessions', sessionIndex)}
                          className="remove-btn"
                        >
                          ✕
                        </button>
                      </div>
                    </div>
                  ))}
                  <button 
                    onClick={() => addArrayItem(index, 'sessions', { date: '', location: '', spots: '' })}
                    className="add-btn"
                  >
                    + Ajouter session
                  </button>
                </div>

                {/* Reviews */}
                <div className="section">
                  <h4>Avis</h4>
                  {(formation.reviews || []).map((review, reviewIndex) => (
                    <div key={reviewIndex} className="review-item">
                      <div className="form-row">
                        <input 
                          type="text" 
                          value={review.name || ''} 
                          onChange={(e) => handleArrayFieldChange(index, 'reviews', reviewIndex, { ...review, name: e.target.value })}
                          placeholder="Nom"
                        />
                        <select 
                          value={review.rating || 5} 
                          onChange={(e) => handleArrayFieldChange(index, 'reviews', reviewIndex, { ...review, rating: parseInt(e.target.value) })}
                        >
                          <option value={5}>5 étoiles</option>
                          <option value={4}>4 étoiles</option>
                          <option value={3}>3 étoiles</option>
                          <option value={2}>2 étoiles</option>
                          <option value={1}>1 étoile</option>
                        </select>
                        <input 
                          type="text" 
                          value={review.date || ''} 
                          onChange={(e) => handleArrayFieldChange(index, 'reviews', reviewIndex, { ...review, date: e.target.value })}
                          placeholder="Date"
                        />
                        <button 
                          onClick={() => removeArrayItem(index, 'reviews', reviewIndex)}
                          className="remove-btn"
                        >
                          ✕
                        </button>
                      </div>
                      <textarea 
                        value={review.comment || ''} 
                        onChange={(e) => handleArrayFieldChange(index, 'reviews', reviewIndex, { ...review, comment: e.target.value })}
                        placeholder="Commentaire"
                        rows={2}
                      />
                    </div>
                  ))}
                  <button 
                    onClick={() => addArrayItem(index, 'reviews', { name: '', rating: 5, comment: '', date: '' })}
                    className="add-btn"
                  >
                    + Ajouter avis
                  </button>
                </div>

              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimpleFormationsAdmin;
